
// プロファイルキャッシュの有効期間（ミリ秒）
export const PROFILE_CACHE_DURATION = 24 * 60 * 60 * 1000; // 24時間
